import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useAllocLog(machineId: number | null) {
  return useQuery({
    queryKey: ["alloc-log", machineId],
    // biome-ignore lint/style/noNonNullAssertion: guarded by enabled
    queryFn: () => api.listAllocLog({ machine_id: String(machineId!) }),
    enabled: machineId !== null && machineId > 0,
  });
}
